import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { dataTableGroup } from '../../constants';
import { useTableContext } from '../../context';
import { ClickableTitle, GroupHeaderWrapper, GroupWrapper, Title } from './styled';
export const Group = memo(function Group({ children, className, title, titleOnClick, tag, actions }) {
    const { inner } = useTableContext();
    const hasActions = Boolean(actions) || Boolean(tag);
    return (_jsxs(GroupWrapper, { className: className, $inner: inner, ...dataTableGroup, children: [_jsxs(GroupHeaderWrapper, { $inner: inner, $hasActions: hasActions, children: [titleOnClick ? _jsx(ClickableTitle, { onClick: titleOnClick, children: title }) : _jsx(Title, { children: title }), tag, actions] }), children] }));
});
